/**
 * Documentation & Support Library — category filter
 *
 * Behavior (mirrors boxlight.com/support/documentation):
 *  - Clicking a category button marks it active and shows only items whose
 *    `data-categories` attribute contains that slug.
 *  - Clicking "All" (__all__) clears the filter and shows every item.
 *  - Supports URL parameter `?category=SLUG` for bookmarkable state.
 *  - Hides items via the `hidden` attribute so CSS can style them out.
 */
(function () {
    if (typeof document === 'undefined') return;

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        const roots = document.querySelectorAll('[data-dsl]');
        if (!roots.length) return;

        roots.forEach(setupRoot);
    }

    function setupRoot(root) {
        const buttons    = root.querySelectorAll('[data-dsl-filter]');
        const items      = root.querySelectorAll('[data-dsl-item]');
        const empty      = root.querySelector('.dsl__empty');
        const scroller   = root.querySelector('[data-dsl-scroller]');
        const scrollBtns = root.querySelectorAll('[data-dsl-scroll]');

        if (!buttons.length || !items.length) return;

        // Side chevron buttons: scroll the category row horizontally
        if (scroller && scrollBtns.length) {
            scrollBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    const direction = parseInt(btn.getAttribute('data-dsl-scroll') || '1', 10);
                    const step = Math.max(160, scroller.clientWidth * 0.6);
                    scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
                });
            });
        }

        const applyFilter = (slug) => {
            let visible = 0;
            items.forEach((item) => {
                const cats = (item.getAttribute('data-categories') || '').split(/\s+/).filter(Boolean);
                const show = slug === '__all__' || cats.indexOf(slug) !== -1;
                if (show) {
                    item.removeAttribute('hidden');
                    visible++;
                } else {
                    item.setAttribute('hidden', '');
                }
            });

            buttons.forEach((btn) => {
                const active = btn.getAttribute('data-dsl-filter') === slug;
                btn.classList.toggle('is-active', active);
                btn.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            if (empty) {
                empty.hidden = visible > 0;
            }
        };

        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const slug = btn.getAttribute('data-dsl-filter') || '__all__';
                applyFilter(slug);

                // Update URL with ?category=slug (or remove for "All")
                try {
                    const url = new URL(window.location.href);
                    if (slug === '__all__') {
                        url.searchParams.delete('category');
                    } else {
                        url.searchParams.set('category', slug);
                    }
                    window.history.replaceState({}, '', url.toString());
                } catch (e) { /* older browsers: ignore */ }
            });

            btn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    btn.click();
                }
            });
        });

        // Initial: read ?category= from URL (first root only on the page)
        try {
            const initial = new URL(window.location.href).searchParams.get('category');
            if (initial) {
                const match = root.querySelector('[data-dsl-filter="' + cssEscape(initial) + '"]');
                if (match) applyFilter(initial);
            }
        } catch (e) { /* ignore */ }
    }

    // Minimal CSS.escape polyfill for older browsers
    function cssEscape(s) {
        if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
        return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
    }
})();
